<template>
  <div class="buttom">
    <div class="top-1">
      <div class="top-1-img"><img src="../image/zrk.png" alt=""></div>
      <div class="top-1-text">报诚守真，科技为魂，忠于职守，报本反使</div>
    </div>
    <div class="middle">
      <div class="d-flex">
        <div class="middle-1">
          <input type="text" placeholder="请输入姓名" class="middle-1-1" v-model="name" required="required">
          <input type="number" placeholder="请输入电话" class="middle-1-2" v-model="phone"
            oninput="if( this.value.length > 11 )  this.value = this.value.slice(0,11)" id="myinput">
          <el-button type="primary" :plain="true" @click="messages" class="middle-1-3">提交</el-button>
        </div>
        <textarea placeholder="请填写您的需求" cols="30" rows="10" class="middle-2" v-model="demand"></textarea>
      </div>
      <div class="middle-3">
        <div class="middle-3-1">
          <img src="../image/iphone.png" alt="" style="width: 1.88rem;height: 1.88rem;">
          <img src="../image/sofa.png" alt="" style="width: 1.88rem; height: 1.94rem;">
          <img src="../image/ip.png" alt="" style="width: 1.38rem;height: 1.88rem;">
        </div>
        <div class="middle-3-2">
          <div class="middle-text">
            <p style="font-size: 1.5rem;">{{ webInfo.phone }}</p>
            <span style="0.88rem">&nbsp;&nbsp;&nbsp;(热线)</span>
          </div>
          <div class="middle-text-2">
            传真:{{ webInfo.landline }}
          </div>
          <div class="middle-text-3">
            {{ webInfo.address }}
          </div>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <router-link class="foot-bottom-item" v-for="item in friendshipList" :key="item.name" :to="item.content">{{
        item.name }}</router-link>
    </div>
  </div>
</template>

<script>
import { api_save_leave, api_friendship_list, api_site_info } from "../APi/api";
export default {
  data() {
    return {
      name: "",
      phone: "",
      demand: "",
      friendshipList: [],
      webInfo: {},
    };
  },
  methods: {
    messages() {
      if (this.name == '') {
        this.$message({
          message: "请输入姓名",
          type: "error",
        });
        return
      }
      if (this.phone == '') {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "error",
        });
        return
      }
      if (this.demand == '') {
        this.$message({
          message: "请输入您的需求",
          type: "error",
        });
        return
      }
      api_save_leave({
        name: this.name,
        phone: this.phone,
        demand: this.demand,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          (this.name = ""), (this.phone = ""), (this.demand = "");
        }else {
          this.$message.error("提交失败");
        }
      });
    },
    // 获取友链
    getFriendshipList() {
      api_friendship_list().then((res) => {
        // console.log('友链',res.data);
        this.friendshipList = res.data;
      });
    },
    getWebInfo() {
      api_site_info().then((res) => {
        // console.log('网站信息', res.data);
        this.webInfo = res.data;
      });
    },
  },
  created() {
    this.getFriendshipList();
    this.getWebInfo();
  },
}
</script>

<style lang="scss" scoped>
.buttom {
  width: 100%;
  height: 23.44rem;
  background-image: url(../image/diBu.png);
  background-size: 100% 100%;

  .top-1 {
    width: 100%;
    height: 6.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .top-1-img {
      margin-top: 1.44rem;
      width: 8.4rem;
      height: 5rem;
    }

    .top-1-text {
      color: #717690;
      font-size: 0.88rem;
      position: relative;
      top: -1rem;
    }
  }

  .middle {
    width: 80rem;
    height: 11rem;
    display: flex;
    flex-direction: row;
    margin: auto;
    margin-top: 2rem;
    justify-content: space-around;

    .d-flex {
      width: 44.5rem;
      height: 11rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .middle-1 {
        width: 20rem;
        height: 11rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;


        .middle-1-1 {
          width: 19.15rem;
          height: 2.63rem;
          color: white;
          background-color: rgba(105, 110, 138, 0.25);
          padding: 0 0.6rem;
          border: none;
          outline: none;
        }

        .middle-1-2 {
          width: 19.15rem;
          height: 2.63rem;
          padding: 0 0.6rem;
          background-color: rgba(105, 110, 138, 0.25);
          border: none;
          color: white;
          outline: none;
        }

        .middle-1-2::-webkit-inner-spin-button,
        .middle-1-2::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .middle-1-3 {
          width: 11.31rem;
          height: 2.63rem;
          background: #1E66DD;
          border-radius: 0.06rem;
          color: white;
          font-size: 1rem;
          border: #1E66DD 1px;
        }
      }

      .middle-2 {
        width: 22.1rem;
        height: 5.7rem;
        background-color: rgba(105, 110, 138, 0.25);
        border: none;
        color: white;
        outline: none;
        padding: 0.6rem 0.6rem;
      }
    }

    .middle-3 {
      width: 30%;
      height: 11rem;
      color: white;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .middle-3-1 {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        align-items: center;
      }

      .middle-3-2 {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        .middle-text {
          display: flex;
          align-items: center;
        }

        .middle-text-2 {
          font-size: 1.13rem;
          margin-top: -0.4rem;
        }

        .middle-text-3 {
          font-size: 1.13rem;
          margin-top: -0.3rem;
        }
      }
    }
  }
}

.foot-bottom {
  width: 74rem;
  height: 3.75rem;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;

  .foot-bottom-item {
    width: 26%;
    text-align: center;
    color: #696E8A;
    text-decoration: none;
  }

  .foot-bottom-item:last-child {
    width: 12%;
    text-align: end;
  }

  .foot-bottom-item:first-child {
    width: 10%;
    text-align: start;
  }
}

// 移动端
@media screen and (max-width: 900px) {

  // 移动
  .buttom {
    width: 100%;
    height: 32rem;
    background-image: url(../image/diBu.png);
    background-size: 100% 100%;

    .top-1 {
      width: 100%;
      height: 6.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .top-1-img {
        margin-top: 1.44rem;
        width: 8.4rem;
        height: 5rem;
      }

      .top-1-text {
        color: #717690;
        font-size: 0.88rem;
        position: relative;
        top: -1rem;
      }
    }

    .middle {
      width: 100%;
      height: 23rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 0;
      .d-flex {
        width: 70%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .middle-1 {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content:normal;
          height: 6rem;
          .middle-1-1 {
            width: 94%;
            height: 2.4rem;
            color: white;
            background-color: rgba(105, 110, 138, 0.25);
            padding: 0 0.6rem;
            margin-bottom: 0.2rem;
            border: none;
            outline: none;
          }

          .middle-1-2 {
            width: 94%;
            height: 2.4rem;
            margin-bottom: 0.2rem;
            padding: 0 0.6rem;
            background-color: rgba(105, 110, 138, 0.25);
            ;
            border: none;
            color: white;
            outline: none;
          }

          .middle-1-2::-webkit-inner-spin-button,
          .middle-1-2::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          .middle-1-3 {
            width: 70%;
            height: 2.63rem;
            background: #1E66DD;
            border-radius: 0.06rem;
            color: white;
            font-size: 1rem;
            border: #1E66DD 1px;
            position: absolute;
            margin-top: 11.4rem;
          }
        }

        .middle-2 {
          width: 94%;
          height: 5.7rem;
          background-color: rgba(105, 110, 138, 0.25);
          border: none;
          color: white;
          outline: none;
          padding: 0.6rem 0.6rem;
        }
      }

      .middle-3 {
        width: 90%;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6rem;
        justify-content: center;
        color: white;
        font-size: 0.8rem;
        margin-top: 3.5rem;

        .middle-3-1 {
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-around;
          align-items: center;

          img {
            width: 1.2rem !important;
            height: 1.2rem !important;
          }
        }

        .middle-3-2 {
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-around;
          align-items: flex-start;
          padding: 0 20px;
          .middle-text {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 0.8rem !important;
            p{
              font-size: 0.8rem !important;
            }
          }
          .middle-text-2 {
          font-size: 0.8rem;
          margin-top: 0rem;
        }

        .middle-text-3 {
          font-size: 0.8rem;
          margin-top: 0rem;
        }
        }
      }
    }
  }

  .foot-bottom {
    width: 100%;
    height: 1.75rem;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: space-evenly;
    font-size: 0.8rem;
    flex-direction: row;

    .foot-bottom-item {
      width: 18%;
      text-align: center;
      color: #696E8A;
      text-decoration: none;
    }

    .foot-bottom-item:last-child {
      width: 18%;
      text-align: end;
    }

    .foot-bottom-item:first-child {
      width: 10%;
      text-align: start;
    }
  }
}
</style>